import { useEffect, useState } from "react";
import { fetchPhysicalEdition } from "../api/physicalEditionApi";
import { physicalEditionCollection } from "../config/physicalEditionConfig";


export const usePhysicalEdition = () => {
  const [data, setData] = useState(physicalEditionCollection);

  useEffect(() => {
    let isMounted = true;

    fetchPhysicalEdition().then((result) => {
      if (isMounted) setData(result);
    });

    return () => {
      isMounted = false;
    };
  }, []);

  return { data };
};
